import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Switch, Route } from 'react-router-dom'
import { hotjar } from 'react-hotjar'
import { ToastContainer } from 'react-toastify'
import { Bootstrap, PageNotFound } from '~/components'
import { usePageTrack } from './service/analytics'
import { Application } from './views/Application'
import 'react-toastify/dist/ReactToastify.min.css'
import { requireAuth } from '~/service/requireAuth'
import { useAuthAccount } from './store/auth/useAuthAccount'
import { Login, RecoverPassword, ResetPassword } from './views'

const HotjarId = process.env.PJ_PANEL_HOTJAR_ID
const HotjarSv = process.env.PJ_PANEL_HOTJAR_SV
const HAS_AUTH_SECTION = window.localStorage && !!window.localStorage.getItem('ID_TOKEN')

export const App: React.FC = () => {
  useEffect(() => {
    if (HotjarId && HotjarSv) {
      hotjar.initialize(Number(HotjarId), Number(HotjarSv))
    }
  }, [])
  usePageTrack()

  const authAccount = useAuthAccount()
  const [bootstrap, setBootstrap] = useState(!HAS_AUTH_SECTION)

  const isAuth = useMemo(() => !!authAccount, [authAccount])

  const handleBootstrapComplete = useCallback(() => {
    setBootstrap(true)
  }, [])

  if (!bootstrap) {
    return <Bootstrap onComplete={handleBootstrapComplete} />
  }

  return (
    <>
      <Switch>
        <Route path='/' exact>
          {requireAuth(Login, isAuth, { notAuth: true, redirectTo: window?.location?.pathname?.length > 1 ? window.location.pathname : '/app/loan-request' })}
        </Route>
        <Route path='/recover' exact>
          {requireAuth(RecoverPassword, isAuth, { notAuth: true, redirectTo: window?.location?.pathname?.length > 1 ? window.location.pathname : '/app/loan-request' })}
        </Route>
        <Route path='/reset/:token/:email' exact>
          {requireAuth(ResetPassword, isAuth, { notAuth: true, redirectTo: window?.location?.pathname?.length > 1 ? window.location.pathname : '/app/loan-request' })}
        </Route>
        <Route path='/app'>
          {requireAuth(Application, isAuth, { redirectTo: '/' })}
        </Route>
        <Route path='/register'>
          {requireAuth(Login, isAuth, { notAuth: true, redirectTo: window?.location?.pathname?.length > 1 ? window.location.pathname : '/app/loan-request' })}
        </Route>
        <Route path='*'>
          <PageNotFound fullscreen />
        </Route>
      </Switch>
      <ToastContainer />
    </>
  )
}
